module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "tada.c39d808e.wav" + "?" + Date.now();